import { useState } from "react"

export const useFeatureInfoVisibility = ({key}) => {
    const localStorageValue = localStorage.getItem(`feature-info-${key}-is-visible`)
    const visible = localStorageValue !== null ? JSON.parse(localStorageValue) : true
    const [isVisible, setIsVisible] = useState(visible)

    const setAndPersistIsVisible = (newValue) => {
        setIsVisible(newValue)
        localStorage.setItem(`feature-info-${key}-is-visible`, JSON.stringify(newValue))
    }

    return [isVisible, setAndPersistIsVisible]
}
